import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import { tickValues, colourPalette, metricLegend, metricFormatFromId } from '../_base';
import CustomToolTip from '../_tooltip';
import { useSelector } from 'react-redux';
import { StringHelpers, SystemText } from 'e4shared';
import { e4Format, e4Formats } from 'helpers/dates';

const Chart = ({ data, item, id }) => {
    if (!data || !data[0] || !data[0][0]) return <div>{SystemText('Dashboard/Widget/General/InvalidData')}</div>;

    const valuesY = data[0].reduce((a, c) => a.concat(c.data), []);
    const valuesX = data[0][0].data;
    const [legend1, setLegend1] = React.useState('Series 1');
    const [format1, setFormat1] = React.useState('Q');
    const [bottomTicks, setBottomTicks] = React.useState([]);
    const [leftTicks, setLeftTicks] = React.useState([]);
    const [leftTicksExtra, setLeftTicksExtra] = React.useState({});

    const metrics = useSelector(state => state.dashboard.metrics);
    const user = useSelector(state => state.user.user);

    React.useEffect(() => {
        const me = document.querySelector(`#${id}`);
        setBottomTicks(tickValues(valuesX, 'x', me.offsetWidth));
    }, [item.w]);

    React.useEffect(() => {
        const me = document.querySelector(`#${id}`);
        let extra = {};
        const lts = tickValues(valuesY, 'y', me.offsetHeight, true, extra, format1);
        setLeftTicks(lts);
        setLeftTicksExtra(extra);
    }, [item.h, format1]);

    React.useEffect(() => {
        if (item?.data) {
            const parsed = JSON.parse(item.data);
            setFormat1(metricFormatFromId(parsed.metric1, metrics));
            setLegend1(metricLegend(parsed.metric1, metrics, user.currencySymbol, legend1));
        }
    }, [item.data]);

    const legendData = data[0].map((d, i) => ({ ...d, color: colourPalette[i % colourPalette.length] }));

    return (
        <ResponsiveLine
            data={data[0]}
            margin={{ top: 10, right: 130, bottom: 50, left: 60 }}
            xScale={{ type: 'point' }}
            yScale={{ type: 'linear' }}
            curve="monotoneX"
            axisTop={null}
            enableGridY
            colors={colourPalette}
            xFormat={x => e4Format(x, e4Formats.monthShort)}
            axisBottom={{
                tickValues: bottomTicks,
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                format: x => e4Format(x, e4Formats.monthShort),
                legend: 'Month',
                legendOffset: 40,
                legendPosition: 'middle',
            }}
            axisLeft={{
                tickValues: leftTicks,
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                format: x =>
                    format1 === 'P' ? parseInt(x * 100, 10) : leftTicksExtra.format ? leftTicksExtra.format(x) : x,
                legend: `${legend1} ${leftTicksExtra.suffix ?? ''}`,
                legendOffset: -50,
                legendPosition: 'middle',
            }}
            enableGridX={false}
            lineWidth={1.2}
            pointSize={8}
            pointColor={{ theme: 'background' }}
            pointBorderWidth={1}
            pointBorderColor={{ from: 'serieColor' }}
            pointLabelYOffset={-12}
            useMesh
            legends={[
                {
                    data: legendData,
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 120,
                    translateY: 0,
                    itemsSpacing: 2,
                    itemWidth: 100,
                    itemHeight: 20,
                    itemDirection: 'left-to-right',
                    itemOpacity: 0.85,
                    symbolSize: 16,
                    symbolShape: 'circle',
                    symbolBorderColor: 'rgba(0, 0, 0, .5)',
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemOpacity: 1,
                            },
                        },
                    ],
                },
            ]}
            tooltip={point => (
                <CustomToolTip
                    point={point}
                    legend={legend1}
                    legendData={legendData}
                    yFormat={x => StringHelpers.formatMetric(format1, point.point.data?.y, user.currencySymbol)}
                />
            )}
        />
    );
};

export default Chart;
